import { useQuery } from '@tanstack/react-query';

import { awaitJSON, MiscLambdaFetch } from '../../utils/fetch-utils';

import { InvoicingCompany } from './invoicing-constants';
import { InvoicingDateRange } from './invoicing-utils';

export const useInvoicingCompanies = (
  invoicingDates: InvoicingDateRange
): ReturnType<typeof useQuery<InvoicingCompany[]>> =>
  useQuery({
    meta: { suppressGlobalError: true },
    queryKey: ['invoicingCompanies', invoicingDates.start, invoicingDates.end],
    queryFn: async (): Promise<InvoicingCompany[]> =>
      awaitJSON<InvoicingCompany[]>(
        await MiscLambdaFetch('/invoicing_companies', {
          params: { start: invoicingDates.start, end: invoicingDates.end }
        })
      )
  });
